import React, { useState } from 'react'

import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { MdEditDocument, MdOutlineSupportAgent } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";

import '../styles/loan.css'
import loanIMG from '../assets'
import { appliedLoan } from '../../../database/actions/account'
const Loan = () => {
  const [formVal, setFormVal] = useState({
    fname: '', mname: '', lname: '', address: '', ssn: '', citizen: '', email: '', amount: '', period: '',
    guarantor: '', gtPhone: '', gtSSN: ''
  });

  const [applyLoan, setApplyLoan] = useState(false)
  const [checkList, setCheckList] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formData = {
    "fname": `${formVal.fname}`,
    "mname": `${formVal.mname}`,
    "lname": `${formVal.lname}`,
    "address": `${formVal.address}`,
    "ssn": `${formVal.ssn}`,
    "citizen": `${formVal.citizen}`,
    "email": `${formVal.email}`,
    "amount": `${formVal.amount}`,
    "period": `${formVal.period}`,
    "guarantor": `${formVal.guarantor}`,
    "gtPhone": `${formVal.gtPhone}`,
    "gtSSN": `${formVal.gtSSN}`,
  }

  const appLoan = async (e) => {
    e.preventDefault();
    setApplyLoan(true)
    setCheckList(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData)
    dispatch(appliedLoan(formData, navigate));
  }

  const handleChange = (e) => {
    setFormVal({ ...formVal, [e.target.name]: e.target.value });
  }
  return (
    <>
      <div className={"loan " + (checkList ? ' hideLoan' : ' showLoan') + (applyLoan ? ' hideLoan' : ' showLoan')}>
        <div className="header" style={{ backgroundImage: `url(${loanIMG.takeLoan})` }}>
          <h2>Need a Loan? <br /> We Can Help.</h2>
        </div>
        <div className="intro">
          <h3>Loans up to $15,000*</h3>
          <p>Life comes at you pretty fast. And sometimes you need a loan to flatten out the bumps.
            We get it. A personal loan from 1st Franklin might be just what you need to tackle a home repair,
            cover a medical expense or simply consolidate your debt. That's why we make Loans for Living™.
            A fixed rate loan with set monthly payments can be the smart way to get back on track. We're here to help you do life.
          </p>
          <ul>
            <li>
              <MdEditDocument />
              <h4>Step 1</h4>
              <p>Apply for loan</p>
            </li>
            <li>
              <MdOutlineSupportAgent />
              <h4>Step 2</h4>
              <p>Contact Admin to discuss your loan and options</p>
            </li>
            <li>
              <GiTakeMyMoney />
              <h4>Step 3</h4>
              <p>Receive funds</p>
            </li>
          </ul>
        </div>
        <div className="loanDeets">
          <ul>
            <li>
              <div className="deets">
                <h5>Step 1</h5>
                <h3>Apply for loan</h3>
                <p>Beginning the loan process is simple. You can start your application online, over the phone or at your local 1st Franklin Financial branch.</p>
                <div className="btn" onClick={() => setApplyLoan(true)}><p>Apply Now</p></div>
                <div className="more">
                  <h4>If you apply online:</h4>
                  <p>In most cases we will contact you immediately, but will assuredly be in touch within two business days.
                    <br />
                    If you submit your loan application during non-business hours, your application will be reviewed the following business day.
                  </p>
                </div>
              </div>
              <div className="img" style={{ backgroundImage: `url(${loanIMG.applyOnline})` }}></div>
            </li>
            <li>
              <div className="deets">
                <h5>Step 2</h5>
                <h3>Contact Admin to discuss offers</h3>
                <p>After your initial approval, you'll have a face to face meeting with your 1st Franklin Financial associate to discuss rates and terms, and complete your application.</p>
                <div className="more">
                  <h4>What to bring with you:</h4>
                  <p>As a part of the application process, you'll need to provide a few documents to secure your loan. We have put together a checklist to help you prepare.</p>
                  <div className="btn" onClick={() => setCheckList(true)}><p>View Checklist</p></div>
                </div>
              </div>
              <div className="img" style={{ backgroundImage: `url(${loanIMG.callSupport})` }}></div>
            </li>
            <li>
              <div className="deets">
                <h5>Step 3</h5>
                <h3>Receive funds</h3>
                <p>After you review and accept your loan terms, you'll sign your loan documents and get your money.
                  <br />
                  You could have the money you need as soon as the next day. In some cases, in only a few hours!
                </p>
              </div>
              <div className="img" style={{ backgroundImage: `url(${loanIMG.deposit})` }}></div>
            </li>
          </ul>
        </div>
      </div>
      <div className={`loanForm ` + (applyLoan ? ' showLoanForm' : ' hideLoanForm')}>
        <h1 onClick={() => setApplyLoan(false)}>Close</h1>
        <h2>Apply For Loan</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-cont transfer-input">
            <input type="text" name="fname" id="fname" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="fname">First Name</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="text" name="mname" id="mname" onChange={handleChange} />
            <div className="underline"></div>
            <label htmlFor="mname">Middle Name (optional)</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="text" name="lname" id="lname" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="lname">Last Name</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="number" name="amount" id="amount" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="lname">Amount</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="date" name="period" id="period" onChange={handleChange} />
            <div className="underline"></div>
            <label htmlFor="address">Loan period</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="text" name="ssn" id="ssn" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="ssn">Social Security Number SSN</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="text" name="citizen" id="citizen" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="citizen">Country of Citizen</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="email" name="email" id="email" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="email">Email Address</label>
          </div>
          <h5>Guarantor:</h5>
          <div className="form-cont transfer-input">
            <input type="text" name="guarantor" id="guarantor" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="guarantor">Guarantor's Full Name</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="tel" name="gtPhone" id="gtPhone" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="gtPhone">Guarantor's Phone</label>
          </div>
          <div className="form-cont transfer-input">
            <input type="text" name="gtSSN" id="gtSSN" onChange={handleChange} required />
            <div className="underline"></div>
            <label htmlFor="gtSSN">Guarantor's SSN</label>
          </div>
          <div className='form-cont transfer-input terms'>
            <input type="checkbox" name="tnc" id="tnc" required />
            <label htmlFor="tnc" className='tnc'> I agree with 1FFC Loan Terms & Condition</label>
          </div>
          <button type="submit" className='btn-hover'>Request</button>
        </form>
      </div>
      <div className={`checkList ` + (checkList ? ' showCheckList' : ' hideCheckList')}>
        <h1 onClick={() => setCheckList(false)}>Close</h1>
        <h2>What Documents Do I Need to Get a Loan with 1st Franklin Financial?</h2>
        <p>At 1ˢᵗ Franklin Financial, we love helping customers get funds fast. As a part of the application process, you'll need to provide us with a few documents to secure your loan. We pride ourselves on making this process quick and easy for our customers, so we put together the following checklist to help you get prepared.*</p>
        <h3>Valid Identification</h3>
        <p>First, we'll need to confirm your identity.  To do that, we'll need 2 primary or 1 primary and 1 secondary proof of ID.</p>
        <ul>
          <h4>Primary Documents:</h4>
          <li><p>Driver's Licenseli</p></li>
          <li><p>State Issued ID</p></li>
          <li><p>U.S. or Foreign Passport</p></li>
          <li><p>Military or Federal Gov't Employee ID</p></li>
          <li><p>Alien Registration Card (Green Card)</p></li>
          <li><p>U.S. Issued Border Crossing Card</p></li>
          <li><p>U.S. Visa</p></li>
        </ul>
        <ul>
          <h4>Secondary Documents:</h4>
          <li><p>Social Security Card</p></li>
          <li><p>U.S. or Foreign Voter's Registration Card</p></li>
          <li><p>U.S. Employment Authorization Card</p></li>
          <li><p>University/College ID</p></li>
          <li><p>Medicaid, Medicare or other health insurance card</p></li>
          <li><p>Utility Bills</p></li>
        </ul>
        <h3>Proof of Address</h3>
        <p>In order to complete the loan application process, we will also need to confirm your address. To prove your address, please provide one of the documents below when you come into a branch.</p>
        <ul>
          <li><p>Utility Bill (less than 90 days old)</p></li>
          <li><p>Valid Gov't or State ID</p></li>
          <li><p>Valid Driver's License</p></li>
          <li><p>Vehicle Registration</p></li>
          <li><p>Copy of Voter Registration Card</p></li>
          <li><p>Copy of Real Estate Property Title</p></li>
          <li><p>Copy of Real Estate Property Tax Bill</p></li>
          <li><p>Copy of Lease Agreement</p></li>
          <li><p>Bank Statement (less than 90 days old)</p></li>
          <li><p>Medical Bill (less than 90 days old)</p></li>
        </ul>
        <h3>Verifiable Income</h3>
        <p>Finally, we will need to verify your income. Please provide one of the documents below so we can finalize the loan amount you will qualify for.</p>
        <ul>
          <li><p>Paystub</p></li>
          <li><p>Bank Statement or Bank Records</p></li>
          <li><p>Tax Return or W-2</p></li>
          <li><p>Government Documentation</p></li>
          <li><p>Written Income Verification from Employer</p></li>
        </ul>
        <p>For most customers, that's it! But, in some situations, we'll need additional documentation. Here are a few scenarios that may require additional paperwork:</p>
        <ul>
          <li><p>Shared Liabilities: If someone pays all or part of a liability in your name, we'll need documentation to support that.</p></li>
          <li><p>Low Credit Score: If your credit score doesn't meet our minimum requirements, we'll require additional collateral.</p></li>
        </ul>
        <p>If you are ready to apply for a loan, get started now with our easy online loan application! Once completed, our “Friendly Franklin Folks” will be in touch to guide you through the rest of the process
          and find a convenient time for you to visit a local branch to complete your application.
        </p>
        <h5 onClick={appLoan}>Apply Now</h5>
        <h6 onClick={() => setCheckList(false)}>Cancel</h6>
      </div>
    </>
  )
}

export default Loan